import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const strava = defineConnector({
  identifier: "strava",
  name: "Strava",
  tagLine: "Fitness tracking and social network",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://www\\.strava\\.com/api/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Strava API application",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [Strava API Settings](https://www.strava.com/settings/api) and create a new application.",
        },
      ],
    },
    {
      title: "Configure your application",
      items: [
        {
          kind: "markdown",
          content:
            "Copy and paste the following redirect URI into your Strava application settings:",
        },
        {
          kind: "copyable",
          label: "Authorization callback domain",
          value: "{API_URL}/connected-apps/oauth/strava/callback",
        },
      ],
    },
    {
      title: "Enter your client credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client Secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Define scopes for this connection",
      items: [
        {
          kind: "markdown",
          content:
            "Add [scopes](https://developers.strava.com/docs/authentication/) in a comma-separated list below.",
        },
        {
          kind: "input",
          label: "Scopes",
          placeholder: "read,activity:read",
          required: true,
          defaultValue: "read",
          helperText: "Comma-separated list of desired scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Authorize your Strava account",
      items: [
        {
          kind: "markdown",
          content:
            "Finally, authorize your Strava account to complete the connection.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
            { kind: "oauthConnection", field: "scopes" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://www.strava.com/oauth/authorize",
    tokenEndpoint: () => "https://www.strava.com/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://www.strava.com/api/v3/athlete",
  },
});
